// extracted by mini-css-extract-plugin
export default {"main":"dashboard_main__qV0rP","logo":"dashboard_logo__GJRxi"};